module.exports = __webpack_public_path__ + "img/class1.ddc5d641.png";